import { render, staticRenderFns } from "./SCteVeiculoEstrutura.vue?vue&type=template&id=ecb200e8"
import script from "./SCteVeiculoEstrutura.vue?vue&type=script&lang=js"
export * from "./SCteVeiculoEstrutura.vue?vue&type=script&lang=js"
import style0 from "./SCteVeiculoEstrutura.vue?vue&type=style&index=0&id=ecb200e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports